import React from 'react';
import {
  ProTextInputWrapper,
  RequiredAsteriskWrapper,
  StyledInput,
  StyledLabel
} from 'elements/forms/inputs/ProTextInput.styles';

interface ProTextInputProps {
  value: string;
  label: string;
  placeholder?: string;
  inputName: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email';
  required?: boolean;
}

const ProTextInput = (props: ProTextInputProps): JSX.Element => {
  const type = props.type || 'text';

  return (
    <ProTextInputWrapper>
      <StyledLabel>
        {props.label}

        {props.required && <RequiredAsteriskWrapper>*</RequiredAsteriskWrapper>}
      </StyledLabel>

      <StyledInput type={type}
                   name={props.inputName}
                   value={props.value}
                   placeholder={props.placeholder}
                   required={props.required}
                   onChange={event => props.onChange(event.target.value)}/>
    </ProTextInputWrapper>
  );
};

export default ProTextInput;
